import React from 'react';
import { Phone, MapPin, Mail, Linkedin, Github } from '../Icons';
import './Footer.css';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" id="footer">
      <div className="footer-wrap">
        <div className="footer-grid">
          <div className="footer-brand-col">
            <h3 className="footer-logo">
              <span>&lt;/</span>Agustin<span>&gt;</span>
            </h3>
            <p className="footer-bio">
              Desarrollador Full Stack apasionado por crear soluciones digitales innovadoras y experiencias de usuario excepcionales.
            </p>
          </div>

          <div className="footer-links-col">
            <h4 className="footer-title">Navegación</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('about')}>Sobre mí</button></li>
              <li><button onClick={() => scrollToSection('projects')}>Proyectos</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contacto</button></li>
            </ul>
          </div>

          <div className="footer-contact-col">
            <h4 className="footer-title">Contacto</h4>
            <ul className="footer-contact-info">
              <li>
                <Phone size={18} />
                <span>+54 11 6976-6847</span>
              </li>
              <li>
                <Mail size={18} />
                <span>agustinrosano7@gmail.com</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>Buenos Aires, Argentina</span>
              </li>
            </ul>
          </div>

          <div className="footer-social-col">
            <h4 className="footer-title">Redes Sociales</h4>
            <div className="footer-social-links">
              <a href="https://www.linkedin.com/in/agustin-rosano-272542204/" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <Linkedin size={20} />
                <span>LinkedIn</span>
              </a>
              <a href="https://github.com/agustinrosano" target="_blank" rel="noopener noreferrer" className="social-link-item">
                <Github size={20} />
                <span>GitHub</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom-info">
          <p className="copyright">
            © {new Date().getFullYear()} <span className="highlight">Agustin Rosano</span>. Hecho con pasión y React.
          </p>
          <p className="footer-disclaimer">Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
